import { render, staticRenderFns } from "./UrlEdit.vue?vue&type=template&id=6c8919b8"
import script from "./UrlEdit.vue?vue&type=script&lang=js"
export * from "./UrlEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports